import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { SocketTopics, MapTopics, TwilioTopics } from "./../constants/enums";
import { pushNotification } from "utils/notifications";
import {
  getItemListRequestPayload,
  wrapRequestPayload,
} from "../helpers/request/RequestPayload";
import { getMembersPageListPath } from "../helpers/request/RequestPath";
import { RID, UID, UUID } from "../constants/localStoreKeys";
import useLocalStorageService from "../services/localStorage";
import moment from "moment";
import { useEventPublisher } from "utils/event";
import {
  GET_PROJECT_LIST,
  GET_ADMIN_ROLES_LIST,
} from "reducers/dashboardReducer";
import {
  getPagesRequestPublishTopic,
  getPageSubscriptionTopic,
  getPageRequestPublishTopic,
  getUserUpdatedTopic,
} from "hooks/MQTTConstants";
import { TwilioError } from "twilio-video";
import { generateUUID } from "utils/appUtil";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import _ from "lodash";

const processMessage = (
  updatedMessages: Array<MessageInfo>,
  payload: MessageInfo
): Array<object> => {
  // const flag = payload.data?.flag;
  const flag = payload.refMessage?.referenceType;
  const originalPageMessageId = payload?.originalPageMessageId;
  if (flag === "update") {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages[index] = payload;
  } else if (flag === "remove") {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages.splice(index, 1);
  } else updatedMessages.push(payload);
  return updatedMessages;
};

export default () => {
  const dispatch = useDispatch();
  const { getLocalStorageItem } = useLocalStorageService();
  const { requestIds } = useSelector((state: RootState) => state.dashboard);

  const [audio, setAudio] = useState<HTMLAudioElement>();
  const publisher = useEventPublisher();
  const { mapType } = useSelector((state: RootState) => state.search);

  const { selected_places } = useSelector(
    (state: RootState) => state.dashboard
  );

  const { lastLocation } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const sound = new Audio("/audio/beep-06.mp3");
    setAudio(sound);
  }, []);

  const getUserRequestPayload = (
    objectId: string,
    path: string = "$",
    returnPath: string = "$"
  ): any => {
    return {
      objectId,
      paths: [path],
      returnPaths: [returnPath],
    };
  };

  const processLastSent = (page) => {
    if (page) {
      let lastSent;
      const groups = page?.persistent?.static?.metadata?.members?.groups ?? {};
      const userGroups = [];
      Object.keys(groups).map((groupName) => {
        if (
          (groups[groupName]?.userIds ?? []).indexOf(
            localStorage.getItem("RID")
          ) !== -1
        )
          userGroups.push(groupName);
      });
      for (let group of ["members", ...userGroups]) {
        if (
          !lastSent ||
          new Date(
            page.nonpersistent?.dynamic?.metadata?.lastSent?.[group]
              ?.updatedAt ?? 1970
          ).getTime() > new Date(lastSent.updatedAt).getTime()
        ) {
          lastSent = page?.nonpersistent?.dynamic?.metadata?.lastSent?.[group];
        }
      }
      page.lastSent = lastSent;
      page.lastRead =
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
          localStorage.getItem("RID")
        ];
      const memberActivity = Object.keys(
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser ?? {}
      );
      let readBy = {};
      if (memberActivity) {
        memberActivity.map((x) => {
          if (
            page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
              ?.pageMessageId ??
            false
          ) {
            if (
              !readBy[
                page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                  ?.pageMessageId
              ]
            )
              readBy[
                page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
                  x
                ]?.pageMessageId
              ] = [];
            readBy[
              page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                ?.pageMessageId
            ].push(x);
          }
        });
      }
      page.currentUserRole =
        page?.persistent?.static?.metadata?.members?.users?.[
          localStorage.getItem("RID")
        ]?.role ?? "edit";
      page.readBy = readBy;
    }
    return page;
  };

  const handlePageResults = (data) => {
    try {
      // let organizedData =
      //   data?.map(
      //     (page) =>
      //       page[Object.keys(page)[0]][0][0] &&
      //       {
      //         pageId: Object.keys(page)[0],
      //         memberActive:
      //           !page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
      //             ?.members?.users?.[localStorage.getItem("RID")]?.pending,
      //         ...page[Object.keys(page)[0]][0][0],
      //       }
      //   ) ?? [];

      let organizedData = data?.map((page) => {
        return {
          ...page,
          pageId: page?.pageId?.toString(),
          memberActive:
            !page?.persistent.static.metadata?.members?.users?.[
              localStorage.getItem("RID")
            ]?.pending,
          activeIot: page?.activeIot?.toString(),
          // activeIot: Object.keys(page?.nonpersistent?.static?.live.activeIot ?? {}).toString()
        };
      });
      organizedData = organizedData.map((page) => {
        page = processLastSent(page);
        return page;
      });
      const filteredData = organizedData
        .filter((data) => data)
        .sort(
          (a, b) =>
            (moment(
              b.lastSent?.updatedAt ?? b.persistent.static.metadata.createdAt
            ) as any) -
            (moment(
              a.lastSent?.updatedAt ?? a.persistent.static.metadata.createdAt
            ) as any)
        );
      // const filtereredData = organizedData;
      console.log("pages", filteredData);
      if (filteredData) {
        dispatch({ type: "SET_SEARCH_RESULT", payload: filteredData });
      }
    } catch (e) {
      console.error("failed to fetch pages", e);
    }
  };

  const handleFocusMap = (data: any) => {
    dispatch(data);
  };

  const handleIotAppend = (payload: any) => {
    let gps = JSON.parse(payload.message);
    if (!gps) {
      return;
    }
    if(gps.data){
      gps = gps.data;
    }
    gps.imei = payload.topic;

    console.log('new gps here', gps);

    if (gps?.samples?.[0]?.dataset?.locationGps) {
    } else {
      return;
    }

    //   {
    //     "meta_data": {
    //         "gps": [
    //             [
    //                 {
    //                     "timestamp": 1652114711901,
    //                     "dataset": {
    //                         "location": {
    //                             "lat": 31.53566,
    //                             "long": 74.414459
    //                         },
    //                         "lat": 31.53566,
    //                         "long": 74.414459
    //                     }
    //                 }
    //             ]
    //         ]
    //     }
    // }

    if (mapType === "HOME") {
      const temp = { ...lastLocation };
      const imei = payload.topic;
      const userId = imei.split("/")?.[4];
      temp[userId].location = {
        latitude: gps?.samples?.[0]?.dataset?.locationGps.lat,
        longitude: gps?.samples?.[0]?.dataset?.locationGps.long,
      };
      dispatch({
        type: "SET_FULL_GPS_LAST_LOCATION",
        payload: temp,
      });
    } else {
      dispatch({
        type: "ADD_GPS",
        payload: {
          response: { data: [{ samples: [gps.samples[0]] }] },
          live: true,
          imei: payload.topic,
        },
      });
    }
  };

  const handleTextMessage = (socket, payload: any) => {
    // const resp = JSON.parse(payload.message).data.messages[0];
    const resp = JSON.parse(payload.message).data;
    const pageId = resp.pageInfo.pageId;
    const message = {
      messageType: resp.message.type,
      createdAt: resp.pageInfo.publishedAt,
      data: resp.message.attributes,
      senderName: `user# ${resp.pageInfo.userId}`,
      senderId: resp.pageInfo.userId,
      message: resp.message.attributes.body,
      pageId,
      id: resp.pageInfo.pageMessageId.toString(),
      originalPageMessageId: resp?.pageInfo?.originalPageMessageId?.toString(),
      originalCreatedAt: resp?.pageInfo?.originalCreatedAt,
      refMessage: resp?.pageInfo?.refMessage,
    };
    if (message.messageType === "log") return;
    if (message.data.notify) {
      audio.play();
    }
    dispatch({ type: "SET_SELECTED_PAGE_MESSAGE", payload: message });
    if (message.messageType === "place") {
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        // MapTopics.FocusMap
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`
      );

      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        // MapTopics.FocusMap,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`,
        {
          type: "ADD_SELECTED_PLACES",
          payload: {
            ...message,
            id: message.id,
            name: message.message,
            objectType: "place",
          },
        }
      );
    } else if (
      message.messageType === "gps" &&
      message?.refMessage?.referenceType === "remove"
    ) {
      dispatch({
        type: "REMOVE_SELECTED_PLACES",
        payload: {
          ...message,
          id: message.id,
          name: message.message,
          objectType: "user",
        },
      });
    }
  };

  const handlePageTyping = (payload: any) => {
    dispatch({ type: "PAGE_TYPING", payload: JSON.parse(payload.message) });
  };
  const handleVideoJoinNotification = (data) => {
    const callNotification = {
      senderId: data.sender,
      page: {
        ...data,
        id: data.pageId,
        videoRoomId: data.roomId,
      },
    };
    dispatch({ type: "SET_INCOMING_CALL", payload: callNotification });
  };
  const handleVideoEndedNotification = (data) => {
    const callNotification = {
      senderId: data.sender,
      page: {
        ...data.page.persistent.static,
        id: data.pageId,
        videoRoomId: data.roomId,
      },
    };
    dispatch({ type: "SET_INCOMING_CALL_ENDED", payload: undefined });
  };

  const handleSaveVideoNotification = (data) => {
    const notification = {
      senderId: data.sender,
      page: {
        ...data.page.persistent.static,
        id: data.pageId,
        videoRoomId: data.roomId,
      },
    };
    dispatch({ type: "SET_SAVE_VIDEO_PROMPT", payload: notification });
  };

  const handleRecordingMediaResult = (payload) => {
    const recordingMedia = JSON.parse(payload.message).data;
    if (recordingMedia.status) {
      const url = recordingMedia.data.url;
      dispatch({ type: "SET_TWILIO_VIDEO_URL", payload: url });
    } else {
      pushNotification(
        "Video recording is being processed. Please try later after some time",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  };

  const handleUser = (socket, topic, payload) => {
    topic = JSON.parse(payload.message).pattern;
    const topics = topic?.split("/");
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getUserUpdatedTopic(),
      wrapRequestPayload({
        pageId: JSON.parse(payload.message)?.data,
      })
    );
    if (topics) {
      if (topics[5] === "eventPageCreated") {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPagesRequestPublishTopic(),
          wrapRequestPayload(
            getItemListRequestPayload([
              getMembersPageListPath(getLocalStorageItem(RID)),
            ])
          )
        );
      } else if (topics[5] === "eventPageRemoved") {
        let page = JSON.parse(payload.message).data;
        dispatch({ type: "PAGE_REMOVE", payload: { pageId: page } });
      } else if (topics[5] === "eventPageUpdated") {
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          getPageSubscriptionTopic()
        );
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(),
          {
            id: JSON.parse(payload.message).data,
            data: {
              objectId: JSON.parse(payload.message).data,
              paths: ["$"],
              returnPaths: ["$"],
              resultType: "value",
            },
          }
        );
      } else if (topics[5] === TwilioTopics.VideoJoin) {
        handleVideoJoinNotification(JSON.parse(payload.message).data);
      } else if (topics[5] === TwilioTopics.VideoEnd) {
        handleVideoEndedNotification(JSON.parse(payload.message).data);
      } else if (topics[5] === TwilioTopics.SaveRecording) {
        handleSaveVideoNotification(JSON.parse(payload.message).data);
      } else if (topics[5] === TwilioTopics.RecordingMediaResult) {
        handleRecordingMediaResult(payload);
      }
    }
  };

  const handleSearchMessageResult = (payload) => {
    const requestId = localStorage.getItem("requestId");
    if (requestId !== JSON.parse(payload.message)?.id) {
      return;
    }
    let messages = JSON.parse(payload.message)?.response?.data ?? [];
    console.log("un parsed messages", messages);

    let updatedMessages = [];
    let pageId;
    // messages = [];
    if (!Array.isArray(messages)) return;
    messages =
      messages?.map((message) => {
        return message.object;
      }) ?? [];

    for (let message of messages) {
      pageId = parseInt(message?.pageInfo?.pageId || '-1');
      if(pageId !== -1){
        message = {
          messageType: message.message.type,
          createdAt: message.pageInfo.createdAt,
          data: message.message.attributes,
          senderName: `user# ${message.pageInfo.userId}`,
          senderId: message.pageInfo.userId,
          message: message.message.attributes.body,
          id: message.pageInfo.pageMessageId.toString(),
          originalPageMessageId:
            message?.pageInfo?.originalPageMessageId?.toString(),
          originalCreatedAt: message?.pageInfo?.originalCreatedAt,

          refMessage: message?.pageInfo?.refMessage,
        };
        updatedMessages.push(message);
      }
    }
    if (pageId) {
      dispatch({
        type: "SET_MESSAGES",
        payload: { messages: updatedMessages, pageId },
      });
    }
  };
  const handleGetPlaces = (payload) => {
    dispatch({
      type: "ADD_MAP_PLACES",
      payload: JSON.parse(payload.message).data,
    });
  };
  const handleGetTokenResult = (payload) => {
    dispatch({
      type: "SET_TWILIO_TOKEN",
      payload: JSON.parse(payload.message).data.data,
    });
  };
  const handleConnectionResult = (payload) => {
    if (JSON.parse(payload.message)?.data?.value) {
      dispatch({
        type: "SET_CONNECTION",
        payload: { groups: JSON.parse(payload.message).data.value },
      });
    }
  };

  const handleMessageFocus = (payload) => {
    const messageId = JSON.parse(payload.message)?.messageId;
    publisher(messageId, { event: "focus" });
  };

  const findNestedObj = (entireObj, keyToFind, valToFind) => {
    let foundObj;
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (nestedValue && nestedValue[keyToFind] === valToFind) {
        foundObj = nestedValue;
      }
      return nestedValue;
    });
    return foundObj;
  };

  const handleSearchInPageResult = (payload) => {
    let page = JSON.parse(payload.message).response.data?.[0]?.[0];
    if (page) {
      page = processLastSent(page);
      if (
        !page?.persistent.static.metadata?.members?.users?.[
          localStorage.getItem("RID")
        ]
      ) {
        return;
      }

      dispatch({
        type: "PAGE_UPDATE",
        payload: {
          pageId: page.objectId,
          ...page,
          memberActive:
            !page?.persistent.static.metadata?.members?.users?.[
              localStorage.getItem("RID")
            ]?.pending,
          // activeIot: Object.keys(page?.nonpersistent?.static?.live.activeIot ?? {}).toString()
          activeIot: undefined,
        },
      });
    }
  };

  const handleCreatePageResult = (socket, payload) => {
    let page = JSON.parse(payload.message).response.data;
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getPageSubscriptionTopic()
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getPageRequestPublishTopic(),
      {
        id: page.id,
        data: {
          objectId: page.id,
          paths: ["$"],
          returnPaths: ["$"],
          resultType: "value",
        },
      }
    );
  };

  const handleUpdatePageResult = (socket, payload) => {
    let response = JSON.parse(payload.message);
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getPageSubscriptionTopic()
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getPageRequestPublishTopic(),
      {
        id: response.id,
        data: {
          objectId: response.id,
          paths: ["$"],
          returnPaths: ["$"],
          resultType: "value",
        },
      }
    );
  };

  const handleSearchBds = (payload) => {
    const response = JSON.parse(payload.message)?.response;
    dispatch({ type: "SEARCH_BDS", payload: response?.data });
  };

  const handleUserBds = (payload) => {
    const response = JSON.parse(payload.message)?.response;
    dispatch({ type: "USER_BDS", payload: response?.data });
  };

  const handleFindUsersToPage = (payload) => {
    const response = JSON.parse(payload.message)?.response;
    dispatch({ type: "FIND_USERS_TO_PAGE", payload: response?.data });
  };

  const handleVideoIotAppend = (payload) => {
    const response = JSON.parse(payload.message);
    dispatch({ type: "VIDEO_IOT", payload: response });
  };

  const handlePageFocus = (payload) => {
    let page = JSON.parse(payload.message).page;
    if (page) {
      page = processLastSent(page);
      dispatch({
        type: "PAGE_FOCUS",
        payload: {
          ...page,
          pageId: page?.pageId.toString(),
          memberActive:
            !page?.persistent.static.metadata?.members?.users?.[
              localStorage.getItem("RID")
            ]?.pending,
          activeIot: undefined,
        },
      });
    }
  };

  const handleGetLastIndex = (payload) => {
    const response = JSON.parse(payload.message);
    dispatch({
      type: "SET_GPS_LAST_LOCATION",
      payload: { id: response?.id, data: response?.response?.data },
    });
  };

  const getProjectList = (payload) => {
    const response = JSON.parse(payload.message)?.response;
    dispatch({
      type: GET_PROJECT_LIST,
      payload: response?.data?.projects ?? [],
    });
  };

  const getAdminRolesList = (payload) => {
    const response = JSON.parse(payload.message);
    dispatch({
      type: GET_ADMIN_ROLES_LIST,
      payload: response?.data?.[0]?.[0] ?? [],
    });
  };

  return {
    handlePageResults,
    handleSearchBds,
    handleUserBds,
    handleFindUsersToPage,
    handleCreatePageResult,
    handleFocusMap,
    handleTextMessage,
    handlePageTyping,
    handleVideoJoinNotification,
    handleVideoEndedNotification,
    handleSaveVideoNotification,
    handleRecordingMediaResult,
    handleUser,
    handleSearchMessageResult,
    handleGetPlaces,
    handleGetTokenResult,
    handleConnectionResult,
    handleSearchInPageResult,
    handleIotAppend,
    handleMessageFocus,
    handleUpdatePageResult,
    handleVideoIotAppend,
    getUserRequestPayload,
    getProjectList,
    getAdminRolesList,
    handleGetLastIndex,
    handlePageFocus
  };
};
